import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { Message, MessageHistoryItem } from 'src/app/models/message.model';
import { MessageService } from 'src/app/services/message.service';

@Component({
    selector: 'messaging-report-message-preview',
    templateUrl: './messaging-report-message-preview.component.html',
    styleUrls: ['./messaging-report-message-preview.component.scss'],
    standalone: false
})
export class MessagingReportMessagePreviewComponent implements OnInit {

  isLoading: boolean = false;
  messageContent: MessageHistoryItem;

  private _activatedRouteParamsSubscription: Subscription;

  constructor(private readonly _activatedRoute: ActivatedRoute,
    private readonly _messageService: MessageService
  ) { }

  ngOnInit(): void {
    this._activatedRouteParamsSubscription = this._activatedRoute.params.subscribe((p) => {
      const companyGuid = p['companyGuid'];
      const messageGuid = p['messageGuid'];

      this.getEmailMessageContent(companyGuid, messageGuid);
    });
  }

  ngOnDestroy(): void {
    this._activatedRouteParamsSubscription?.unsubscribe();
  }

  private getEmailMessageContent = (companyGuid: string, messageGuid: string) => {
    this.isLoading = true;
    this._messageService.getMessageDetails(companyGuid, messageGuid).subscribe({
      next: (details) => {
        this.isLoading = false;
        this.messageContent = details as unknown as MessageHistoryItem;
      },
      error: (e) => {
        this.isLoading = false;
      }
    })
  }

}
